import { render, staticRenderFns } from "./gc-footer-save-button.vue?vue&type=template&id=2d06b62c&scoped=true"
import script from "./gc-footer-save-button.vue?vue&type=script&lang=js"
export * from "./gc-footer-save-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d06b62c",
  null
  
)

export default component.exports